module.exports = __webpack_public_path__ + "img/logo@2x.dc551693.png";